export function formatDate(date: string | Date) {
  let dtObject = null;
  if (typeof date === "string") {
    dtObject = new Date(date);
  } else {
    dtObject = date;
  }

  return dtObject?.toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
